"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfilePage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var user_1 = require("../../../reducers/slices/user");
var main_1 = require("../../../reducers/slices/main");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var address_1 = require("./address");
var details_1 = require("./details");
var additional_info_1 = require("./additional_info");
var sampleAppController_1 = require("../../../../facetec/src/sampleAppController");
var pep_pip_verification_1 = require("../pep_pip_verification");
var generate_referral_1 = require("../../../api/calls/referral/generate_referral");
var clipBoard_1 = require("../../../helpers/clipBoard");
var referralLink_1 = require("../../../helpers/referralLink");
var ProfilePage = function () {
    var _a, _b;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var _c = (0, react_1.useState)(false), isLoading = _c[0], setIsLoading = _c[1];
    var handleVerificationSuccess = function () {
        sampleAppController_1.SampleApp.onPhotoIDMatchPressed();
    };
    var handleReferralCode = function () { return __awaiter(void 0, void 0, void 0, function () {
        var referralCode, referralUrl, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    setIsLoading(true);
                    return [4 /*yield*/, (0, generate_referral_1.callGenerateReferralCode)()];
                case 1:
                    referralCode = _a.sent();
                    if (!referralCode) {
                        return [2 /*return*/, undefined];
                    }
                    referralUrl = (0, referralLink_1.buildReferralLink)(referralCode);
                    return [4 /*yield*/, (0, clipBoard_1.copyToClipboard)(referralUrl)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, { referralCode: referralCode, referralUrl: referralUrl }];
                case 3:
                    error_1 = _a.sent();
                    console.error("Failed to retrieve referral code:", error_1);
                    return [2 /*return*/, undefined];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "grid overflow-y-auto items-center w-96 h-full" },
        react_1.default.createElement("div", { className: "flex flex-col" },
            react_1.default.createElement("div", { className: "flex clear-both flex-row gap-2 justify-center items-center text-5xl" },
                react_1.default.createElement("div", { className: "" },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faUserCircle }))),
            react_1.default.createElement("div", { className: "flex flex-col justify-center items-center" },
                react_1.default.createElement("div", { className: "flex flex-col gap-2 items-center" },
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Profile", size: "2xlarge", textColor: "text-secondary", bold: true }),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "".concat(user.name, " ").concat(user.surname), size: "xsmall", textColor: "text-secondary" }),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "".concat(user.email), size: "xsmall", textColor: "text-secondary" }),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "(".concat((_a = user.cell_number) === null || _a === void 0 ? void 0 : _a.country_code, ") ").concat((_b = user.cell_number) === null || _b === void 0 ? void 0 : _b.phone_number), size: "xsmall", textColor: "text-secondary" })),
                react_1.default.createElement("div", { className: "flex flex-row gap-4 justify-center self-stretch pt-4" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Orders History", backgroundColor: "bg-transparent", size: "xsmall", textColor: "text-secondary", iconColor: "text-secondary", startIcon: pro_solid_svg_icons_1.faChartBar, onClick: function () {
                            dispatch((0, main_1.setDrawerOpen)(false));
                            navigate("/orders");
                        } }),
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Wishlist", backgroundColor: "bg-transparent", size: "xsmall", textColor: "text-secondary", iconColor: "text-secondary", startIcon: pro_solid_svg_icons_1.faHeart, onClick: function () {
                            dispatch((0, main_1.setDrawerOpen)(false));
                            navigate("/wishlist");
                        } }))),
            react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                react_1.default.createElement(details_1.ProfileDetailsWidget, null),
                react_1.default.createElement(address_1.ProfileAddressWidget, null),
                react_1.default.createElement(additional_info_1.AdditionalInfoWidget, null)),
            react_1.default.createElement("div", { className: "flex justify-evenly" },
                user.SumSubApproved ? null : (react_1.default.createElement("div", { className: "py-2 w-48" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Verify Identity", backgroundColor: "bg-secondary", onClick: function () {
                            dispatch((0, main_1.setContentModal)({
                                title: "Prominent Influential Person (PIP) Declaration",
                                content: react_1.default.createElement(pep_pip_verification_1.PepPipVerification, { onProceed: handleVerificationSuccess }),
                            }));
                        } }))),
                react_1.default.createElement("div", { className: "py-2" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Referral", loading: isLoading, enabled: !isLoading, backgroundColor: "bg-secondary", onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                            var referral;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, handleReferralCode()];
                                    case 1:
                                        referral = _a.sent();
                                        if (!referral) {
                                            dispatch((0, main_1.setMessageModal)({
                                                title: "Something went wrong!",
                                                messages: ["We couldn't create your referral link. Please try again."],
                                            }));
                                            return [2 /*return*/];
                                        }
                                        dispatch((0, main_1.setContentModal)({
                                            title: "Referral Copied",
                                            content: (react_1.default.createElement("p", null,
                                                "Link copied to clipboard for code:",
                                                " ",
                                                react_1.default.createElement("a", { href: referral.referralUrl, className: "text-secondary hover:underline hover:font-bold" }, referral.referralCode))),
                                        }));
                                        return [2 /*return*/];
                                }
                            });
                        }); } }))),
            react_1.default.createElement("div", { className: "flex flex-col justify-center items-center" },
                react_1.default.createElement("div", { className: "flex flex-row gap-4 justify-center self-stretch pt-4" },
                    react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Log Out", backgroundColor: "bg-secondary", size: "xsmall", startIcon: pro_solid_svg_icons_1.faSignOut, onClick: function () {
                            dispatch((0, user_1.sign_out_thunk)());
                        } }))))));
};
exports.ProfilePage = ProfilePage;
